<template>
<div class="activity strava">
    <figure>
        <img :src="'https://maps.googleapis.com/maps/api/staticmap?size=350x234&maptype=roadmap&path=enc:' + item.map + '&key=' + g_key" />
    </figure>
    <div class="activity__content">
        <p class="title is-6">{{item.when}} <i>/</i> STRAVA</p>
        <div class="columns is-aligned-vertical">
            <div class="column"><h3 class="title is-4">{{item.title}}</h3></div>
            <div class="column is-narrow achievements">
                <span class="icon"><i class="fas fa-trophy"></i></span> {{item.achievements}}
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <span class="is-block">Distance</span>
                <p class="title stats is-6">{{item.distance}}km</p>
            </div>
            <div class="column">
                <span class="is-block">Pace</span>
                <p class="title stats is-6">{{item.pace}} /km</p>
            </div>
            <div class="column">
                <span class="is-block">Duration</span>
                <p class="title stats is-6">{{item.duration}}</p>
            </div>
        </div>
        <div class="content">
            <p>This blog post is automatically created by using Strava's API.</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name    :   'StravaActivity',
    props   :   ['g_key', 'item']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/StravaActivity.vue